import { Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

import ColorSelector from "../components/ColorSelector/ColorSelector";
import ShowExitRow from "../components/ShowExitRow";

export default function GeneralStyling() {
	const { translate } = useLocales();
	return (
		<Stack gap={2}>
			<Typography variant='h6' sx={{ mb: 0 }}>
				{translate("customization.general_style")}
			</Typography>
			<ColorSelector title={translate("customization.primary_color")} name='primaryColor' />
			<ColorSelector
				title={translate("customization.background_page")}
				name='pageBackgroundColor'
			/>
			<ColorSelector
				title={translate("customization.background_container")}
				name='contentBackgroundColor'
			/>
			<ShowExitRow />
		</Stack>
	);
}
